import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CurrencyMaskInputMode } from 'ngx-currency';
import { FundingService } from '../../../../shared/services/funding.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KycService } from '../../../../shared/services/kyc.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare const MonnifySDK: any;

@Component({
    selector: 'app-dashboard-fund',
    templateUrl: './fund.component.html',
    styleUrls: ['./fund.component.scss'],
})
export class FundComponent implements OnInit {

    modalRef: BsModalRef;
    @ViewChild('template', { static: false }) templateRef: TemplateRef<any>;
    amount: number;
    activeOption: number = 1;
    fundIndex: number = 1;
    recurringIndex: number = 1;
    isRecurringSet: boolean = false;
    activeMethod: string;
    todayDate = new Date();
    converted: number;
    currency: string;

    currencyOptions = {
        align: 'left',
        allowNegative: false,
        allowZero: false,
        decimal: '.',
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: ',',
        nullable: true,
        min: null,
        max: null,
        inputMode: CurrencyMaskInputMode.NATURAL,
    };
    fundOptions = [
        {
            name: 'Funding',
            image: 'assets/img/funding.svg',
            id: 1,
        },
        // {
        //     name: 'Set up Direct Debit',
        //     image: 'assets/img/recurring.svg',
        //     id: 2,
        // },
    ];
    fundMethods = [
        {
            name: 'Bank Transfer',
            logo: '',
            id: 1,
        }
    ];
    reference: string;
    references: string;
    exchangeRate: any;
    usExchangeRate: number;
    userinfo: any;
    vwallet: any
    walletId: string;
    virtualAccount: string;
    result: any;
    MNfref: string;
    wallet: any;
    fee: number;
    total: number;
    newamount: number;
    content: any;
    errMsg: string;
    error: boolean;
    check: boolean;

    // Computed Properties
    get title() {
        if (this.activeOption === 1) return 'Direct Funding';
        return 'Recurring Funding';
    }

    get showNextButton() {
        if (this.activeOption === 1) return this.fundIndex == 1;
        return this.recurringIndex > 1 && this.recurringIndex < 5;
    }
    get showBackButton() {
        if (this.activeOption === 1) return this.fundIndex > 1;
        return this.recurringIndex > 1;
    }


    // Methods
    switchOption(id: number) {
        this.activeOption = id;
        this.fundIndex = 1;
        this.recurringIndex = 1;
    }

    switchMethod(name: string) {
        this.activeMethod = name;
        this.references = name.toUpperCase();


        const source = 'API';
        this.nextFunding();
        this.converted = this.amount * this.exchangeRate;

        this.api
            .PaymentGeneratePayRef(this.references, source)
            .subscribe((res: any) => {
                if (res.code == 200) {
                    this.reference = res.data;
                    this.MNfref = this.reference;
                }

                else
                    this.toastr.error(
                        'Please try again',
                        'Something went wrong!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 5000,
                        }
                    );
            },
                (err) => {
                    this.errMsg = err.error.message;

                    if (this.errMsg === undefined)
                        this.errMsg = 'Network Error. Please check your connectivity.'
                    else {
                        this.errMsg = err.error.message;
                    }

                    this.toastr.error(
                        this.errMsg,
                        'Something went wrong!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 5000,
                        }
                    );

                });
    }

    openModal() {
        this.modalService.show(this.templateRef);
    }

    logoutModal(content) {
        this.ngbmodalService.open(content, { backdropClass: 'light-blue-backdrop' });
    }

    closeModal() {
        this.bsModalRef.hide();
        this.route.navigate(['/dashboard/portfolio']);
    }

    channels() {

        this.SpinnerService.show();
        this.api.channels().subscribe((res: any) => {

            if (res.code == 200) {
                this.result = res.data;
                this.result.forEach((element, index) => {
                    this.fundMethods.push({
                        name: element.name,
                        logo: element.imageUrl,
                        id: index + 1,
                    });

                });

            }
            this.SpinnerService.hide();
        }, err => {
            this.SpinnerService.hide();
            this.error = true;
            this.errMsg = err.error.message;
        });
    }

    getTodayRate() {
        this.api.rate().subscribe((res: any) => {
            if (res.code == 200) {
                this.exchangeRate = res.data.buy;
                this.usExchangeRate = res.data.sell;
            }
            else {
                this.exchangeRate = 0;
                this.usExchangeRate = 0;
            }

        },
            err => {
                this.exchangeRate = err.error.message;
            });
    }

    makePayment(form) { }

    getUsersInfo() {
        this.api.UserInformation().subscribe((res: any) => {
            if (res.code == 200) {
                this.userinfo = res.data;
                this.walletId = this.userinfo.id;
                this.getWallet();
            }
            else {
                this.check = true;
                this.errMsg = 'Network Error. Please check your connectivity.'
            }
        },
            (err) => {

                this.check = true;
                this.errMsg = err.error.message;

                if (this.errMsg === undefined)
                    this.errMsg = 'Network Error. Please check your connectivity.'
                else {
                    this.errMsg = err.error.message;
                }
            });
    }


    //get VirtualAccount
    getWallet() {
        this.router.params.subscribe((params) => {
            this.walletapi.getWallet(this.walletId).subscribe((res: any) => {
                this.vwallet = res.data;
                let type = this.vwallet.filter(
                    (virtual) =>
                        virtual.productType == 'ADVISORY' &&
                        virtual.provider == 'DW'
                );

                this.virtualAccount = type[0].VirtualAccount;
            });
        });
    }



    //still need rework
    paymentDone($event) {


        if (($event.message = 'Aproved')) {
            this.SpinnerService.show();
            this.api
                .confirmPayment(
                    this.amount,
                    'USD',
                    'PAYSTACK',
                    $event.reference,
                    true,
                    'success',
                    'ADVISORY'
                )
                .subscribe(
                    (res: any) => {
                        if (res) {
                            this.result = res;
                            this.toastr.success(
                                'Payment  confirmed !',
                                'Success!',
                                {
                                    positionClass: 'toast-top-center',
                                    timeOut: 5000,
                                }
                            );
                            this.fee = res.data.fee;
                            this.newamount = res.data.amount;
                            this.total = this.fee + res.data.amount;
                            this.currency = res.data.currencyCode;
                            this.MNfref = res.data.transactionReference;
                            this.SpinnerService.hide();

                            this.ngbmodalService.open(this.templateRef, { backdropClass: 'light-blue-backdrop' });
                            this.route.navigate(['/dashboard/portfolio']);
                        } else {
                            this.SpinnerService.hide();
                            this.toastr.warning(
                                'Payment could not be confirmed !',
                                'Something went wrong!',
                                {
                                    positionClass: 'toast-top-center',
                                    timeOut: 5000,
                                }
                            );
                        }
                    },
                    (err) => {
                        this.SpinnerService.hide();
                        this.errMsg = err.error.message;

                        if (this.errMsg === undefined)
                            this.errMsg = 'Network Error. Please check your connectivity.'
                        else {
                            this.errMsg = err.error.message;
                        }

                        this.toastr.error(
                            this.errMsg,
                            'Something went wrong!',
                            {
                                positionClass: 'toast-bottom-center',
                                timeOut: 5000,
                            }
                        );
                    }
                );


        }
    }

    payWithMonnify() {

        MonnifySDK.initialize({
            amount: this.converted,
            currency: 'NGN',
            reference: this.reference,
            customerFullName: this.userinfo.username || '',
            customerEmail: this.userinfo.email,
            customerMobileNumber: this.userinfo.mobileNumber || '',
            apiKey: 'MK_TEST_JC82CV2PRP',
            contractCode: '7456839164',
            paymentDescription: 'Test Pay',
            isTestMode: true,
            metadata: {
                name: this.userinfo.username || '',
                age: 45,
            },
            onComplete: (response) => {
                this.MNfref = response.transactionReference;
            },
            onClose: (data) => {
                //Implement what should happen when the modal is closed here
                this.SpinnerService.show();
                this.api
                    .confirmPayment(
                        data.amountPaid,
                        'USD',
                        'MONNIFY',
                        data.transactionReference,
                        'true',
                        'success',
                        'ADVISORY'
                    )
                    .subscribe(
                        (res: any) => {
                            if (res.data) {
                                this.toastr.success(
                                    'Payment  confirmed !',
                                    'Success!',
                                    {
                                        positionClass: 'toast-top-center',
                                        timeOut: 5000,
                                    }
                                );
                                this.fee = res.data.fee;
                                this.newamount = res.data.amount;
                                this.currency = res.data.currencyCode;
                                this.total = this.fee + res.data.amount;
                                this.SpinnerService.hide();

                                this.ngbmodalService.open(this.templateRef, { backdropClass: 'light-blue-backdrop' });
                                this.route.navigate(['/dashboard/portfolio']);

                            } else {
                                this.toastr.warning(
                                    'Payment could not be confirmed !',
                                    'Something went wrong!',
                                    {
                                        positionClass: 'toast-top-center',
                                        timeOut: 5000,
                                    }
                                );
                            }
                        },
                        (err) => {
                            this.SpinnerService.hide();

                            this.errMsg = err.error.message;

                            if (this.errMsg === undefined)
                                this.errMsg = 'Network Error. Please check your connectivity.'
                            else {
                                this.errMsg = err.error.message;
                            }


                            this.toastr.error(
                                err.error.message,
                                'Something went wrong!',
                                {
                                    positionClass: 'toast-bottom-center',
                                    timeOut: 6000,
                                }
                            );
                        }
                    );
            },
        });
    }

    submitHandler(event: any) {

        const ref = this.reference;
        if (!ref) {
            return;
        }
        const name = this.userinfo.username;
        const amounts = this.amount;
        const value = (this.converted * 100).toString();

        const onComplete = (res) => {
            console.log(res, 'isw')
            if (res.resp === "00") {
                this.confirmISW(value, ref, amounts);
            }
        }

        const paymentRequest = {
            merchant_code: 'MX13651',
            pay_item_id: '9264129',
            txn_ref: ref,
            amount: value,
            currency: 566,
            site_redirect_url: window.location.href,
            onComplete: onComplete.bind(this),
            mode: 'TEST'
        };

        (window as any).webpayCheckout(paymentRequest);

    }

    confirmISW(value, reference, amounts) {
        this.SpinnerService.show();
        this.api
            .confirmPayment(
                value,
                'USD',
                'INTERSWITCH',
                reference,
                true,
                'success',
                'ADVISORY'
            )
            .subscribe(
                (res: any) => {
              
                    if (res) {
                        this.result = res;
                        this.toastr.success(
                            'Payment  confirmed !',
                            'Success!',
                            {
                                positionClass: 'toast-top-center',
                                timeOut: 5000,
                            }
                        );
                        this.fee = res.data.fee;
                        this.newamount = res.data.amount;
                        this.total = this.fee + res.data.amount;
                        this.currency = res.data.currencyCode;
                        this.MNfref = res.data.transactionReference;
                        this.SpinnerService.hide();

                        this.ngbmodalService.open(this.templateRef, { backdropClass: 'light-blue-backdrop' });
                        this.route.navigate(['/dashboard/portfolio']);
                    } else {
                        this.SpinnerService.hide();
                        this.toastr.warning(
                            'Payment could not be confirmed !',
                            'Something went wrong!',
                            {
                                positionClass: 'toast-top-center',
                                timeOut: 5000,
                            }
                        );
                    }
                },
                (err) => {
                    this.SpinnerService.hide();
                    this.SpinnerService.hide();

                    this.errMsg = err.error.message;

                    if (this.errMsg === undefined)
                        this.errMsg = 'Network Error. Please check your connectivity.'
                    else {
                        this.errMsg = err.error.message;
                    }


                    this.toastr.error(
                        err.error.message,
                        'Something went wrong!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 6000,
                        }

                    );
                })
    }

    paymentCancel() { }


    editRecurring() {
        this.isRecurringSet = false;
        this.recurringIndex = 2;
    }

    nextFunding() {

        this.fundIndex += 1;
        if (this.fundIndex === 1) {

        }
        else {
            return console.log('fund index', this.fundIndex)
        }
    }

    nextRecurring() {
        this.recurringIndex += 1;
    }

    goBackFunding() {
        if (this.fundIndex > 1) this.fundIndex -= 1;
    }

    goBackRecurring() {
        if (this.recurringIndex > 1) this.recurringIndex -= 1;
    }

    constructor(private api: FundingService,
        private route: Router,
        private router: ActivatedRoute,
        private SpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private ngbmodalService: NgbModal,
        private walletapi: KycService) { }

    ngOnInit() {
        const interswitch = document.createElement('script');
        interswitch.async = true;
        interswitch.src =
            'https://qa.interswitchng.com/collections/public/javascripts/inline-checkout.js';
        document.body.appendChild(interswitch);

        const monnify = document.createElement('script');
        monnify.async = true;
        monnify.src = 'https://sandbox.sdk.monnify.com/plugin/monnify.js';
        document.body.appendChild(monnify);

        this.getTodayRate();
        this.getUsersInfo();
        this.channels()
    }
}
